export default __webpack_public_path__ + "static/colore-elettroni-952524675ff4c29433c8ba0d247ee1e8.svg";